import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

document.addEventListener('DOMContentLoaded', function() {
  let lastState = null;
  
  function hideTaxExemption() {
    const el = document.getElementById('ooTaxExemption');
    if (el && el.getAttribute('data-initialized') === 'true') {
      const validatedInfoVisible = el.querySelector('#oo-validated-info');
      const taxSuccessElements = el.querySelectorAll('.oo-tax-succes');
      let hasVisibleSuccess = false;
      
      taxSuccessElements.forEach(element => {
        const computedStyle = window.getComputedStyle(element);
        if (computedStyle.display !== 'none') {
          hasVisibleSuccess = true;
        }
      });
      
      const isValidated = 
        validatedInfoVisible || 
        hasVisibleSuccess;
      
      if (lastState !== isValidated) {
        lastState = isValidated;
        
        if (isValidated) {
          el.style.display = 'none';
        } else {
          el.style.display = 'block';
        }
      }
    } 
  }

  setTimeout(hideTaxExemption, 500);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && 
          (mutation.target.id === 'ooTaxExemption' || 
           mutation.target.closest('#ooTaxExemption'))) {
        hideTaxExemption();
        break;
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
});